<div class="title">
  მიუთითე სადაზღვევო პერიოდი
</div>
<form [formGroup]="form">
  <div class="row">
    <div class="col-lg-6">
      <div class="form-group mt-4">
        <label for="phone">დაწყების თარიღი</label>
        <div class="has-datepicker FormInput mb-l ta-l position-relative" *ngIf="form.get('startDate'); let startDate;">
          <input formControlName="startDate" [minDate]="minstartDate" [maxDate]="maxstartDate" type="text"
            class="form-control" name="startDate" placeholder="დდ/თთ/წწწწ" bsDatepicker #dp="bsDatepicker"
            autocomplete="off" [readonly]="true" [bsConfig]="{ adaptivePosition: true }"
            [ngClass]="{'has-error': !startDate.valid && submitted}" (bsValueChange)= "changeStartDate($event)">
          <span class="txt">-დან</span>
          <i class="fas fa-calendar-alt date-picker" (click)="dp.toggle()" [attr.aria-expanded]="dp.isOpen"></i>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="form-group mt-4">
        <label for="phone">დასრულების თარიღი</label>
        <div class="has-datepicker FormInput mb-l ta-l position-relative" *ngIf="form.get('endDate'); let endDate;">
          <input formControlName="endDate" [minDate]="minendDate" [maxDate]="maxendDate" type="text"
            class="form-control" name="endDate" placeholder="დდ/თთ/წწწწ" bsDatepicker #dp="bsDatepicker"
            autocomplete="off" [readonly]="true" [bsConfig]="{ adaptivePosition: true }"
            [ngClass]="{'has-error': !endDate.valid && submitted}">
          <span class="txt">-ჩათვლით</span>
          <i class="fas fa-calendar-alt date-picker" (click)="dp.toggle()" [attr.aria-expanded]="dp.isOpen"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="sheet-buttons g g--spaceAround g--wrap g--nowrap@s g--alignEnd mt-5">
    <app-prev-btn></app-prev-btn>
    <app-next-btn (click)="onSubmit()"></app-next-btn>
  </div>
</form>
